import http from '../../HttpConfig'
import {APIS_ENDPOINTS} from '../../SERVICE-CONSTANTS'

const backCheques_endpoints = APIS_ENDPOINTS.facilityinquiry;
const facilityinquiryboardofdirectors_endpoints = APIS_ENDPOINTS.facilityinquiryboardofdirectors;

export const request_getallfacilityinquirybyuserprofileid = async ({userId}: {userId: number}) => {
  return http.get(
    backCheques_endpoints.getallfacilityinquirybyuserprofileid + '?UserProfileId=' + userId
  )
}

export const request_getallboardofdirectorsbyuserprofileid = async ({userId}: {userId: number}) => {
  return http.get(
    facilityinquiryboardofdirectors_endpoints.getallboardofdirectorsbyuserprofileid + '?UserProfileId=' + userId
  )
}
